import React, {FC} from 'react'
import styles from './styles.module.scss'

interface NoResultsProps {
  header: string
  text: string,
  className?: string
}

export const NoResults: FC<NoResultsProps> = ({header, text, className}) => {
  return (
    <div className={`${styles.noResults} ${className || ''}`}>
      <div className={styles.header}>{header}</div>
      <div className={styles.text}>{text}</div>
    </div>
  )
}